import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class UnmarkChatAsSpamArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string
}

export interface IUnmarkChatAsSpam extends IAction<Chat, UnmarkChatAsSpamArgs> {}
